import { useQuery } from '@tanstack/react-query';
import { Template } from '../types';
import { useApiEssentials } from '../../../shared/hooks/useApiEssentials';
import { get } from '../../../shared/api/apiService';

export function useTemplates() {
  const { getIdToken, apiUrl, isSignedIn } = useApiEssentials();

  return useQuery({
    queryKey: ['templates'],
    queryFn: async () => {
      const idToken = await getIdToken();
      return await get<Template>('/templates', apiUrl, idToken);
    },
    enabled: isSignedIn,
    retry: false,
  });
}
